import React from 'react';
import { Trans } from 'react-i18next';
import * as S from './PaymentAgreementText.styles';
import { ROUTES } from '@/constants/routes';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const PaymentAgreementText = () => {
  return (
    <S.Text $variant="1">
      <Trans
        i18nKey="pages.ad.agree_gdpr_policy"
        components={{
          link1: <CustomLink target="_blank" href={ROUTES.terms} />,
          link2: <CustomLink target="_blank" href={ROUTES.proposal} />,
        }}
      />
    </S.Text>
  );
};
